import { Box } from "@mui/material";
import {
  AboutTile,
  FleetTile,
  HeroSection,
  ReviewTile,
  ServiceTile,
} from "../../components";
import { MapsTile } from "../../components/Maps/MapsTile";
import { CTABanner } from "../../common/BookBanner";
import { useGetRequest } from "../../common/Services/api";
import { useEffect } from "react";

export const HomePage = () => {
  const { data, fetchData } = useGetRequest();
  useEffect(() => {
    fetchData();
    console.log("Initial BE request: ", data);
  }, [fetchData, data]);
  return (
    <Box>
      <HeroSection />
      <AboutTile />
      <ServiceTile />
      {/* <LocationsTile /> */}
      <MapsTile />
      <FleetTile />
      <ReviewTile />
      <Box sx={{ my: { xs: 4, sm: 5 } }}>
        <CTABanner />
      </Box>
    </Box>
  );
};
